import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Navbar from "./navbar";
import Footer from "./footer";
const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

const NewsletterUploadForm = () => {
  const { register, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(true);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);
    setMessage("");

    const formData = new FormData();
    formData.append("text", data.text);
    formData.append("htmlPage", data.htmlPage[0]);
    formData.append("backgroundImage", data.backgroundImage[0]);
    formData.append("blogImages", data.blogImages[0]);

    try {
      const response = await fetch(`${BASE_URL}/newsletter/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData,
      });
      if (response.ok) {
        setMessage("Newsletter uploaded successfully!");
        reset();
      } else {
        setMessage("Failed to upload newsletter.");
      }
    } catch (error) {
      setMessage("Failed to upload newsletter.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setShowPopup(true);
  }, []);
  

  return (
    <>
      <Navbar />
      <div className="main-content text-center mt-5">
        
      </div>
      
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
            
            <h2 className="text-center fw-bold">Upload Newsletter</h2>
            <div></div>
          </div>
            {message && (
              <p className={`text-center mt-3 ${message.includes("successfully") ? "text-success" : "text-danger"}`}>
                {message}
              </p>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
              <div className="mb-3">
                <label htmlFor="text" className="form-label fw-bold">
                  Newsletter Text
                </label>
                <textarea
                  id="text"
                  {...register("text", { required: true })}
                  className="form-control"
                  rows="1"
                  placeholder="Enter newsletter text..."
                />
              </div>
              <div className="mb-3">
                <label htmlFor="htmlPage" className="form-label fw-bold">
                  Upload HTML Page
                </label>
                <input
                  type="file"
                  id="htmlPage"
                  {...register("htmlPage", { required: true })}
                  accept=".html"
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="backgroundImage" className="form-label fw-bold">
                  Upload Background Image
                </label>
                <input
                  type="file"
                  id="backgroundImage"
                  {...register("backgroundImage", { required: true })}
                  accept="image/*"
                  className="form-control"
                />
              </div>
              <div className="text-end">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Uploading..." : "Submit"}
                </button>
                <button className="btn btn-primary text-left" onClick={() => navigate('/homePage')} style={{marginLeft:'10px'}}>
                  Back
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
      <Footer />
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .popup-container {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 50%;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </>
  );
};

export default NewsletterUploadForm;
